export interface FarmUser {
  id: number;
  name: string;
  email: string;
  farmcode: string;
  farm_role: number;
  firstName: string;
  lastName: string;
  authorized: string;
  verified: number;
}

export interface FarmUsersResponse {
  success: boolean;
  data: FarmUser[];
}

export type FarmType = "competitor" | "organization";

export interface InviteUserRequest {
  farm: string;
  email: string;
  name: string;
  farm_role: number;
  farm_type?: FarmType;
  phone?: string;
}

export interface InviteUserResponse {
  success: boolean;
  message: string;
  user_id: number;
}

export interface DeleteUserRequest {
  farm: string;
  userId: number;
}

export interface DeleteUserResponse {
  success: boolean;
  message: string;
}

export interface ResetPasswordRequest {
  farm: string;
  userId: number;
}

export interface ResetPasswordResponse {
  success: boolean;
  message: string;
  new_password: string;
}

export interface ApiError {
  success: false;
  error: {
    code: string;
    message: string;
  };
}

export const FARM_ROLES = {
  OWNER: 0,
  ADMIN: 1,
  USER: 3,
  SUPPORT_USER: 4,
} as const;

export type FarmRole = (typeof FARM_ROLES)[keyof typeof FARM_ROLES];

export interface UpdateUserResponse {
  success: boolean;
  message: string;
  password_reset_sent: boolean;
}

export type UpdateUserRequest = {
  userId: string;
  farm: string;
  name: string;
  email: string;
  farm_role: FarmRole;
};

export interface DeclineInvitationRequest {
  farm: string;
  userId: number;
}

export interface DeclineInvitationResponse {
  success: boolean;
  message: string;
}

export const getFarmRoleDisplayName = (role: number): string => {
  switch (role) {
    case FARM_ROLES.OWNER:
      return "Owner";
    case FARM_ROLES.ADMIN:
      return "administrator";
    case FARM_ROLES.USER:
      return "ordinary user";
    case FARM_ROLES.SUPPORT_USER:
      return "Support User";
    default:
      return "Unknown";
  }
};

export const isAdminOrHigher = (role: number): boolean => {
  return role <= FARM_ROLES.ADMIN;
};
